export enum StoryCardImagePosition {
  TOP,
  CENTER,
  BOTTOM
}
